import _ from 'lodash';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').SMSMessage} SMSMessage
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * @typedef {Object} GetSMSMessagesActionOpts
 * @property {string} organization
 *
 * @callback GetSMSMessagesAction
 * @param {ActionContext} ctx
 * @param {GetSMSMessagesActionOpts} opts
 * @returns {Promise<Account>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {GetSMSMessagesAction}
 */
export const getSMSMessages = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({}, opts);
  if (!opts.organization) throw new Error(`${nms}: Organization filter is required`);

  // fetch from sdk
  const query = {
    organization: opts.organization
  };
  const messages = await sdk.sms().find(query).then(r => r.items);
  ctx.commit('setSMSMessages', messages);

  return messages;
};

/**
 * @typedef {Object} CreateSMSMessageActionOpts
 * @property {string} organization
 * @property {string} message
 * @property {string} provider
 * @property {string[]} recipients
 * @property {string[]} groups
 * @property {Object.<string,any>} metadata
 *
 * @callback CreateSMSMessageAction
 * @param {ActionContext} ctx
 * @param {CreateSMSMessageActionOpts} opts
 * @returns {Promise<Account>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {CreateSMSMessageAction}
 */
export const createSMSMessage = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({}, opts);
  const { organization, message, provider, recipients, groups, metadata } = opts;
  if (!organization) throw new Error(`${nms}: Organization required`);
  if (!message) throw new Error(`${nms}: Message required`);
  if (!provider) throw new Error(`${nms}: Provider required`);
  // FIXME: this isn't how groups should be used
  //  groups should be a filter for all patients and not just the selected ones
  const filteredRecipients = recipients
    .filter(px => _.intersection(groups, px.personalDetails.tags).length)
    .map(px => ({ type: 'medical-patient', id: px.id }));
  if (!filteredRecipients.length) throw new Error(`${nms}: At least 1 recipient is required`);

  // build message
  const data = {
    organization,
    message,
    provider,
    metadata: _.pick(metadata, 'appid', 'shortcode', 'appsecret', 'passphrase'),
    recipients: filteredRecipients
  };
  const smsmessage = await sdk.sms().create(data);
  ctx.commit('updateInSMSMessages', { upsert: true, items: [ smsmessage ] });
  return smsmessage;
};
